import React, { useState } from "react";
import Dictionary from "../../../utils/Dictionary";
import dictionaryData from "../../../../constants/Data";
import Figure3 from "./Figure3";
import Figure4 from "./Figure4";
import Figure6 from "./Figure6";
import Figure7 from "./Figure7";
import Figure10 from "./Figure10";
import Figure11 from "./Figure11";
import Figure27 from "./Figure27";
import Figure5 from "./Figure5";
import Figure8 from "./Figure8";
import Figure30 from "./Figure30";
import Figure31 from "./Figure31";

const Article = () => {
  const [hoveredWord, setHoveredWord] = useState(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseOver = (e) => {
    const word = e.target.innerText;
    const definition = dictionaryData[word];

    if (definition) {
      setHoveredWord({ word, definition });
      setPosition({ x: e.clientX, y: e.clientY });
    } else {
      setHoveredWord(null);
    }
  };

  const handleMouseOut = () => {
    setHoveredWord(null);
  };
  return (
    <div className="mb-20">
      {hoveredWord && (
        <Dictionary
          word={hoveredWord.word}
          definition={hoveredWord.definition}
          position={position}
        />
      )}
      <div>{/**Labels for the Figures */}
         {/*Figure 1*/}{/** */}
        {/*Figure 2*/}{/** Proteinase K*/}
        {/*Figure 3*/}{/** BCA amount of loaded protein */}
        {/*Figure 4*/}{/**Cadmium blanks */}
        {/*Figure 5*/}{/** Cadmium 0.029 */}
        {/*Figure 6*/}{/**Cadmium 0.025*/}
        {/*Figure 7*/}{/** Zinc 0.31*/}
        {/*Figure 8*/}{/** BCA amount of loaded protein */}
        {/*Figure 9*/}{/** Zinc ----------------*/}
        {/*Figure 10*/}{/**Zinc 0.3*/}
        {/*Figure 11*/}{/** */}{/** Zinc 0.38*/}
        {/*Figure 12*/}{/**Mucus binding final epxeriment count 1 */}
        {/*Figure 13*/}{/**Mucus binding final epxeriment count 2 */}
        {/*Figure 14*/}{/**Half-Life linear standard curve D2 */}
        {/*Figure 16*/}{/**------- */}
        {/*Figure 17*/}{/**------- */}
        {/*Figure 18*/}{/** --------*/}
        {/*Figure 19*/}{/**--------- */}
        {/*Figure 20*/}{/**---------- */}
        {/*Figure 21*/}{/**--------- */}
        {/*Figure 22*/}{/**--------- */}
        {/*Figure 23*/}{/** ------------*/}
        {/*Figure 24*/}{/** ------------*/}
        {/*Figure 25*/}{/** ------------*/}
        {/*Figure 26*/}{/** ------------*/}
        {/*Figure 27*/}{/** blank Zinc*/}
      </div>
       
        


      <div>
        <h2 id="EC20_e">EC20 </h2>
        <hr className="dividergeneral mb-5"></hr>
          <p className=" mb-2" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
          In the following sections we will elaborate the results on our journey to make our bacteria express EC20 
          on their outer membranes to enable them to catch cadmium from their environment.
          </p>
          <div>{/*Expression of EC20 */}
            <h3 className=" mb-5 mt-10" id="Expression_EC20_e">Expression of EC20: </h3>
              <p className=" mb-2"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
              After bacterial <span>transformation</span> with the <span>plasmid</span> harbouring the EC20 construct, our primary objective 
              was to validate the <span>expression</span> of the target protein. 
              </p>
              <div>{/*Western 1*/}
              <h4 className="mb-3" id="Western1">Western blot analysis: </h4>
                <p className=" mb-20"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                We subjected the EC20 bacteria to <span>sonication</span> and conducted a <span>Western blot</span> analysis. 
                Although the <span>Ponceau S staining</span> indicated the presence of protein, our Western blot failed to 
                detect the <span>6xHis-Tag</span> of our EC20 <span>construct</span> (<a href="#Figure1">Figure 1</a>).
                </p>

                <div class="result-centered">
                  <figure>
                    <img
                      id="Figure1"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/first-western-ec20.jpg"
                      alt="results ec20 ponceau"
                      class="result-image"
                      style={{ width: "50%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 1:</u>{" "}
                      </b>
                      Ponceau S staining for loading control (left) and corresponding Western blot (right).
                    </figcaption>
                  </figure>
                </div>

                <p className=" mb-2"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                <u><b>Conclusion:</b></u><br></br>
                Despite numerous attempts and <span>positive controls</span> to assess <span>antibody</span> quality, conventional Western 
                blotting failed to produce any detectable signal for EC20. In light of this, we made the decision 
                to explore an alternative method that does not rely on antibody binding for protein detection: 
                <a href="#Coomassie1"> coomassie blue staining</a>.                
                </p>
              </div>
              <div>{/*Coomassie 1*/}
              <h4 className="mb-3" id="Coomassie1_e">Analysis of purified protein using coomassie blue staining: </h4>
                <p className=" mb-20"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                To circumvent the dependency on antibody-based methods, we utilized coomassie blue staining for the 
                detection of our EC20 construct, which had been previously purified using the incorporated <span>6xHis-Tag</span>. 
                The expected <span>molecular weight</span> of the EC20 protein band is approximately 22 <span>kDa</span>. In 
                <a href="#Figure3"> Figure 2</a>, we present the outcomes of the <span>coomassie blue staining</span> procedure 
                for purified EC20, alongside a positive control and their respective lysates obtained during the <span>purification process</span>. 
                The positive control consisted of a <span>protein fused</span> with a His-Tag, with an 
                approximate molecular weight of 70 kDa.<br></br>
                The <span>lysate</span> contains an excessive amount of protein, making it challenging to distinguish individual 
                bands. Upon comparing the lanes containing the purified proteins, it becomes evident that all the 
                bands appearing in one condition also manifest in the other. Consequently, none of them can be 
                attributed to EC20 or the control. <br></br>
                <a href="#Figure4">Figure 3</a> confirms the effectiveness of the purification process. The Western 
                blot shows clear bands at expected molecular weights for the control, but none for EC20.
                </p>

                <div class="result-centered mb-20">
                  <figure>
                    <img
                      id="Figure2"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/coomassie-blue-ec20-his-comassie.jpg"
                      alt="results - coomassie blue"
                      class="result-image"
                      style={{ width: "55%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 2:</u>{" "}
                      </b>
                      Coomassie blue staining of purified protein from EC20-hosting bacteria and corresponding 
                      lysate, alongside purified protein from the positive control (His control) and corresponding 
                      lysate.
                    </figcaption>
                  </figure>
                </div>

                <div class="result-centered mb-20">
                  <figure>
                    <img
                      id="Figure3"
                      src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/coomassie-blue-ec20-his-western.jpg"
                      alt="results coomassie ponceau"
                      class="result-image"
                      style={{ width: "85%" }}
                    />
                    <br></br>
                    <figcaption className="mt-2 mb-10">
                    <b>
                        <u>Figure 3:</u>{" "}
                      </b>
                        Ponceau S staining (left) and Western blot (right) with lysate and purified protein from EC20-hosting 
                        bacteria and control strain.

                      </figcaption>
                  </figure>
                </div>
                
                
                <p className=" mb-20" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>{/*Unexpected observation */}
                <u><b>Unexpected observations:</b></u><br></br>
                During the process of lysing, we made an intriguing observation regarding the behaviour of EC20 
                bacteria in comparison to the control strain. The bacteria were resuspended in lysis buffer and 
                subsequently incubated at room temperature with shaking for 20 minutes. Notably, even during the <span>resuspension</span> step, we required significantly more pipetting to achieve an equivalent level of 
                mixing for EC20. <br></br>
                <a href="#Figure4_EC">Figure 4</a> provides a visual representation of the Eppendorf tubes 
                containing the positive control and the EC20 bacteria after incubation. It's apparent that the 
                control mixture was well-mixed, whereas the EC20 bacteria clumped together and precipitated.<br></br>
                Despite these challenges related to mixing that could potentially lead to lysis issues, the <span>purification</span> was continued. <span>nickel particles</span> were introduced into the lysate, and the solution was 
                placed on a magnetic rack. The nickel particles bind to the Histidine tags present on the proteins. 
                Interestingly, the magnetic rack pulled the EC20 construct-expressing bacteria as well 
                (<a href="#Figure5">Figure 5</a>), suggesting that the nickel particles bound to a protein on the 
                surface of the bacteria, which could be either the His-tag or the EC20 protein itself. After several 
                mixing steps involving the nickel particles, the pellet eventually dissolved.<br></br>
                Our current hypothesis suggests that EC20 proteins may exhibit an affinity for each other, causing 
                bacteria to aggregate. When the nickel particles bind to the His tag, they may disrupt the 
                interaction between EC20 proteins, ultimately causing the detachment of the cells.
                </p>

                <div class="result-centered">
                  <figure>
                    <div class='result-div'>{/**Mixing Eppendorf*/}
                      <img
                        id="Figure4_EC"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/phenotype-ec20-after-mixing.jpg"
                        alt="results pcr backbone"
                        class="result-image"
                        style={{ width: "75%" }}
                      />                      
                    </div>
                    <div class='result-div'>{/**Magnetic rack*/}
                        <img
                          id="Figure5"
                          src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/phenotype-ec20-magnetic-rack.jpg"
                          alt="results phenotype spac after mixing"
                          class="result-image"
                          style={{ width: "75%" }}
                        />                     
                    </div>                    
                    <br></br>
                    <div class='result-div'>{/**Mixing Eppendorf Caption*/}
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 4:</u>{" "}
                        </b>
                        EC20-hosting bacteria and positive control bacteria in lysing buffer after 20 minutes of 
                        incubation with shaking.  
                      </figcaption>                    
                    </div>
                    <div class='result-div'>{/**Magnetic rack Caption*/}
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 5:</u>{" "}
                        </b>
                        EC20-hosting bacteria adhering to beads and relocated by the magnetic forces of the 
                        magnetic rack.
                      </figcaption>                     
                    </div> 
                  </figure>
                </div>

                <p className=" mb-2" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>{/*Remarks */}
                <u><b>Remarks:</b></u><br></br>
                After the experiment, it was discovered that our <span>OD meter</span> had consistently provided inaccurate 
                readings. Consequently, the induction of the positive control did not adhere to the original 
                protocol. This deviation in protein induction may explain the absence of apparent <span>overexpression</span> of the control protein.<br></br>
                Furthermore, it's important to note that the volume of lysing buffer used was calculated based on 
                the OD measurements of the bacterial culture. However, for the sake of reproducibility, it should 
                be emphasized that due to the previously mentioned discrepancy in OD readings, the amount of buffer 
                added was 2-6 times lower than intended.
                </p>
                <p className=" mb-2"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>{/*Outlook */}
                <u><b>Conclusions:</b></u><br></br>
                While the Western blot confirmed the success of the purification, we could not isolate the <span>specific</span> band that would indicate the presence of overexpressed proteins. Consequently, we have chosen to 
                discontinue the method of staining purified proteins for the detection of EC20. However, the 
                observed change in bacterial phenotype during purification supports the presence of EC20.<br></br>
                Further investigation into Western blots revealed that <span>SDS boiling</span>, may not sufficiently denature <span>disulfide bridges</span>. 
                EC20 contains 20 repeats of <span>glutamic acid</span> and <span>cysteine</span>, and disulfide bridges 
                can form between cysteine residues. It is possible that remaining disulfide bridges are hindering 
                antibody binding.<br></br>
                In the upcoming experiment, we plan to boil EC20-hosting bacteria using a combination of urea and 
                DTT to effectively <span>denature</span> potential disulfide bridges.
                </p>
              </div>
              <div>{/*Urea DTT*/}
              <h4 className="mb-3" id="Urea_DTT_e">Western blot analysis EC20 – DTT & urea denaturation: </h4>
                <p className=" mb-2"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                  We investigated two conditions to denature potential disulfide bridges: <span>boiling</span> with <span>DTT</span>, both 
                  with and without pre-treatment with <span>Urea</span>. Furthermore, for each condition, we conducted an 
                  experiment using a doubled volume of bacteria, increasing it from 1 mL to 2 mL.<br></br>
                  However, the Western blot yielded no detectable signal, appearing completely black (<a href="#Figure8">Figure 6</a>).
                  This could be attributed to unspecific binding of the primary or <span>secondary antibody</span> to the 
                  membrane, or there may be issues with the reagents or equipment.<br></br>
                  As a result, no conclusions can be drawn from this experiment, and it will need to be repeated.<br></br>
                  While assessing our equipment, we discovered that the luminol solution emitted a signal on its 
                  own, leading us to replace the solution (<a href="#Figure9">Figure 7</a>). <br></br>
                  In the subsequent Western blot experiments, samples treated with urea displayed a signal at the 
                  expected size of approximately 22 kDa for EC20 (<a href="#Figure10_EC">Figure 9</a>). Boiling 
                  with DTT alone, without prior Urea treatment, produced a weaker signal for the 2 mL culture and 
                  no signal for the 1 mL culture.<br></br>
                  From these results, we can infer that the EC20 protein is indeed challenging to denature. With 
                  gentle boiling alone, the 6xHis-Tag may not be sufficiently accessible, leading to the protein's 
                  undetectability.
                </p>

                <div class="result-centered">
                  <figure>
                    <div class='result-div-middle-align'>{/**Black Western*/}
                      <img
                        id="Figure8"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/black-western-urea-dtt.jpg"
                        alt="results expression ponceau s d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div class='result-div-middle-align'>{/**Luminol Comparison*/}
                      <img
                        id="Figure9"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/black-western-luminol-comparison.jpg"
                        alt="results expression ponceau s d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div class='result-div'>{/**Black Western Caption*/}
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 6:</u>{" "}
                        </b>
                        Western blot all black.
                      </figcaption>
                    </div>
                    <div class='result-div'>{/**Luminol Comparison Caption*/}
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 7:</u>{" "}
                        </b>
                        Comparison of our luminol solution to a control
                      </figcaption>
                    </div>
                  </figure>
                </div>
                <div class="result-centered">
                  <figure>
                    <div class='result-div-middle-align'>{/**Ponceau S*/}
                      <img
                        id="Figure8"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/urea-dtt-ponceau-s.jpg"
                        alt="results expression ponceau s d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div class='result-div-middle-align'>{/**western*/}
                      <img
                        id="Figure10_EC"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/urea-dtt-western.jpg"
                        alt="results expression ponceau s d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div class='result-div'>{/**Ponceau S Caption*/}
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 8:</u>{" "}
                        </b>
                        Loading control (Ponceau S staining) for Western blot of EC20 construct-expressing bacteria 
                        with conditions treated with or without urea either 1 mL of bacterial culture or 2 mL.
                      </figcaption>
                    </div>
                    <div class='result-div'>{/**Western Caption*/}
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 9:</u>{" "}
                        </b>
                        Western blot of EC20-hosting bacteria with conditions treated with or without urea either 
                        1 mL of bacterial culture or 2 mL.
                      </figcaption>
                    </div>
                  </figure>
                </div>
                <p className=" mb-2"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                  <u><b>Conclusions:</b></u><br></br>
                  Since we determined that EC20 is indeed <span>expressed</span>, and we could then proceed with the surface 
                  expression and metal binding experiments, described in the following sections.           
                </p>
              </div>
          </div>

          <div>{/*Surface display of EC20 */}
          <h3 className=" mb-5 mt-10" id="Surface_Expression_EC20_e">Surface expression of EC20: </h3>
          <p className=" mb-2"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            Having confirmed protein expression, our next objective is to determine if the protein is present on 
            the bacterial membrane. <br></br>
            We initially intended to conduct a <span>proteinase K experiment</span> to investigate this; 
            however, due to technical difficulties, the experiment was unsuccessful (<a href="#What_did_go_wrong_e">What went wrong</a>).
          </p>
            <div>{/*IF*/}
            <h4 className="mb-3" id="Immunofluorescence_EC20_e">Immunofluorescence (IF) analysis of EC20: </h4>
              <p className=" mb-2"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>

              We tested two fixation protocols, one using <span>ethanol</span> and the other using <span>formaldehyde</span>. <br></br> 
              Surface expression would be identified by observing signal overlap among bacteria with <span>DAPI staining</span> and 
              the fluorescent signal indicating the presence of the His-tag on the EC20. The bacteria will not 
              be permeabilized, ensuring that only the surface protein contributes to the signal.<br></br>
              Immunofluorescence using ethanol fixation and anti-His antibody staining revealed an increased number 
              of green signals compared to the negative control (<a href="#Figure10">Figure 10</a>). However, it's 
              worth noting that these signals only partially overlapped with the positions of the bacteria, as 
              indicated by the DAPI stain.<br></br>
              Formaldehyde fixation yielded similar results. With the Histidine antibody, signals were observed for 
              EC20, albeit not precisely co-located with bacterial positions. Conversely, the <span>negative control</span> mostly 
              lacked signals, except for an artifact signal in the upper right region (<a href="#Figure11">Figure 11</a>).
              </p>

              <div class="result-centered">
                <figure>
                <div class='result-div-middle-align'>{/**Ethanol*/}
                      <img
                        id="Figure10"
                        src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-failed-ethanol-ec20.jpg"
                        alt="results expression ponceau s d1d2"
                        class="result-image"
                        style={{ width: "100%" }}
                      />
                </div>
                <div class='result-div-middle-align'>{/**Formaldehyde*/}
                  <img
                    id="Figure11"
                    src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/if-failed-formaldehyde-ec20.jpg"
                    alt="results expression ponceau s d1d2"
                    class="result-image"
                    style={{ width: "100%" }}
                  />
                </div>
                <div class='result-div'>{/**Ethanol Caption*/}
                  <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 10:</u>{" "}
                      </b>
                      Ethanol-fixed sample with anti-His antibody staining. Blue: DAPI stain, green: His-tag. 
                      Testing sample: EC20-hosting bacteria, negative control: SpaC-hosting bacteria.
                    </figcaption>
                </div>
                <div class='result-div'>{/**Formaldehyde Caption*/}
                  <figcaption>
                    <b>
                      <u>Figure 11:</u>{" "}
                    </b>
                    Formaldehyde-fixed sample with anti-His antibody staining. Blue: DAPI stain, green: His-tag. 
                    Testing sample: EC20-hosting bacteria, negative control: SpaC-hosting bacteria.
                  </figcaption>
                </div>
                  <br></br> 
                </figure>
              </div>

              <p className=" mb-2">
                <u><b>Remarks:</b></u><br></br>
                Interestingly, the EC20-expressing bacteria exhibited a distinct phenotype compared to the typical 
                BL21 strain. They appeared smaller and rounder in shape, deviating from the usual rod-shaped 
                morphology.               
              </p>
              <p className=" mb-2">
                <u><b>Conclusions:</b></u><br></br>
                The absence of signals in Western blots without extensive denaturation indicates that the antibody 
                cannot bind to the folded protein. Regrettably, we cannot achieve the necessary protein 
                denaturation for an immunofluorescence assay.<br></br>
                Due to these limitations and the unavailability of suitable enzymatic activity of proteinase K, we were unable to provide evidence that EC20 is displayed on 
                the surface of the bacteria.
              </p>
            </div>
          </div> 
          <div>{/*Cadmium binding */}
          <h3 className=" mb-5 mt-10" id="Cadmium_Binding_EC20_e">Cadmium binding of EC20: </h3>
            <p className=" mb-2">{/*Intro Cadmium Binding */}
            Given the successful expression of EC20 in our bacteria and the observed changes in phenotype, we are 
            confident in proceeding with the cadmium binding experiments. Initially, we will use zinc as a proxy 
            due to the high toxicity of cadmium.
            </p>
            <div>{/*Zinc Binding*/}
              <h4 className="mb-3" id="Zinc_Binding_EC20_e">Evaluation of zinc capture capacity </h4>
                <p className=" mb-2">
                In previous experiments, we optimized the conditions for the zinc experiment, determining the 
                optimal OD600 of 0.3 for bacterial culture and a concentration of 1.25 mg/L for zinc.<br></br>
                For the sake of reproducibility, it is essential to highlight that we later identified inaccuracies 
                in our OD machine, with the actual OD values being 4 to 6 times higher than those reported by our 
                machine.<br></br>
                In the zinc experiment, we examined incubation times of 15 (<a href="#Figure12_EC">Figure 12</a>) and 
                30 minutes (<a href="#Figure13">Figure 13</a>, <a href="#Figure15"> 15</a>, <a href="#Figure16_EC">16</a>).
                We found that the incubation time did not substantially alter the difference in zinc uptake between 
                the control and test strains. Incubation with EC20-expressing bacteria resulted in 30–50% higher 
                zinc clearance compared to the negative control.
                </p>

                <div class="result-centered">
                  <figure>
                    <div>{/*First two experiments*/}
                    <div id="Figure12_EC"></div>
                    <Figure7 />
                    <figcaption>
                      <b>
                        <u>Figure 12:</u>{" "}
                      </b>
                       Incubation of a 1.25 mg/L zinc solution with EC20-construct expressing bacteria 
                      (OD600 of 0.3) for 15 minutes, along with uninduced SpaC (negative control) and a control 
                      with no additional bacteria (Water). Concentrations were determined using colorimetric kits. 
                      The first two lines represent blank measurements. The column 'Minus blank' already subtracts 
                      the blank values. The uptake of zinc was 32.6% higher EC20-construct expressing bacteria than
                      for the control.
                    </figcaption>
                    <div id="Figure13"></div>
                    <Figure8/>
                    
                    <figcaption className="mt-2 mb-10">
                      <b>
                        <u>Figure 13:</u>{" "}
                      </b>
                      Incubation of a 1.25 mg/L zinc solution with EC20-construct expressing bacteria (OD600 of 0.3) 
                      for 30 minutes, along with uninduced SpaC (negative control) and a control with no additional 
                      bacteria (Water). Concentrations were determined using colorimetric kits. The first two lines 
                      represent blank measurements. The column 'Minus blank' already subtracts the blank values.
                      The uptake of zinc was 51.8% higher EC20-construct expressing bacteria than for the control.

                    </figcaption>
                    </div>
                    <div>{/*blank*/}
                    <div id="Figure14"></div>
                    <Figure27/>                    
                    <figcaption>
                      <b>
                        <u>Figure 14:</u>{" "}
                      </b>
                      Blank values used for <a href="#Figure15">Figures 15</a> and <a href="#Figure16_EC">16</a>.
                    </figcaption> 
                    </div>  
                    <div>{/*last two experiments*/}  
                    <div id="Figure15"></div> 
                    <Figure10/> 
                    <figcaption>
                      <b>
                        <u>Figure 15:</u>{" "}
                      </b>
                      Incubation of a 1.25 mg/L zinc solution with EC20-construct expressing bacteria (OD600 of 0.3) 
                      for 30 minutes, along with uninduced SpaC (negative control) and a control with no additional 
                      bacteria (Water). Concentrations were determined using colorimetric kits, with blank values 
                      subtracted (<a href="#Figure14">Figure 14</a>).
                      The uptake of zinc was 44.8% higher EC20-construct expressing bacteria than for the control.
                    </figcaption> 
                    <div id="Figure16_EC"></div>
                    <Figure11/>
                    <figcaption>
                      <b>
                        <u>Figure 16:</u>{" "}
                      </b>
                      Incubation of a 1.25 mg/L zinc solution with EC20-construct expressing bacteria (OD600 of 0.3) 
                      for 30 minutes, along with uninduced SpaC (negative control) and a control with no additional 
                      bacteria (Water). Concentrations were determined using colorimetric kits, with blank values 
                      subtracted (<a href="#Figure14">Figure 14</a>).
                      The uptake of zinc was 52.8% higher EC20-construct expressing bacteria than for the control.
                    </figcaption>
                    </div>
                  </figure>
                </div>

                
                <p className=" mb-2">
                  <u><b>Conclusions:</b></u><br></br>
                  The experiment with zinc indicated that our EC20 expressing bacteria can bind and capture zinc. 
                  This positive result allowed us to validate our safety measures for our subsequent cadmium 
                  binding experiment. 
                </p>
              </div>
              <div>{/*Cadmium Binding*/}
              <h4 className="mb-3" id="Cadmium_Binding_EC20_e">Cadmium binding experiment: </h4>
                <p className=" mb-2">
                The cadmium binding experiment was conducted using a cadmium solution with a concentration of 0.3 
                mg/L, which had been determined as optimal in a previous experiment. When incubated with 
                EC20-expressing bacteria at an OD600 of 0.06, there was a 21% higher reduction of cadmium compared 
                to the control (<a href="#Figure18">Figure 18</a>). Further reducing the OD to 0.01 accentuated 
                the difference even more. Incubation with EC20-expressing bacteria resulted in a 104% greater 
                clearance of Cd as compared to the negative control (<a href="#Figure19">Figure 19</a>).            
                </p>

                <div class="result-centered">
                  <figure>
                    <div id="Figure17"></div>
                    <Figure4/>
                    <figcaption>
                      <b>
                        <u>Figure 17:</u>{" "}
                      </b>
                      Blank values used for <a href="#Figure18">Figure 18</a> and <a href="#Figure19">19</a>.
                    </figcaption>
                    <div id="Figure18"></div>
                    <Figure5 />
                    <figcaption>
                      <b>
                        <u>Figure 18:</u>{" "}
                      </b>
                      Incubation of a 0.3 mg/L cadmium solution with EC20-construct expressing bacteria (OD600 of 
                      0.06) for 30 minutes, along with uninduced SpaC (negative control) and a control with no 
                      additional bacteria (Water). Concentrations were determined using colorimetric kits. 
                      Concentrations were determined using colorimetric kits, with blank values subtracted 
                      (<a href="#Figure17">Figure 17</a>).
                      The uptake of cadmium was 21% higher EC20-construct expressing bacteria than for the control.
                    </figcaption>

                    <div>
                      <div id="Figure19"></div>
                      <Figure6 />
                    </div>
                    <div>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 19:</u>{" "}
                        </b>
                        Incubation of a 0.3 mg/L cadmium solution with EC20-construct expressing bacteria (OD600 of 
                        0.01) for 30 minutes, along with uninduced SpaC (negative control) and a control with no 
                        additional bacteria (Water). Concentrations were determined using colorimetric kits. 
                        Concentrations were determined using colorimetric kits, with blank values subtracted 
                        (<a href="#Figure17">Figure 17</a>).
                        The uptake of cadmium was 104% higher EC20-construct expressing bacteria than for the control.
                      </figcaption>
                    </div>
                  </figure>
                </div>

                
                <p className=" mb-2">
                  <u><b>Conclusions:</b></u><br></br>
                  We have successfully demonstrated that our bacteria are capable of capturing cadmium. 
                </p>
              </div>
          </div> 

          <h2 className="mt-20" id="What_did_go_wrong_e">What went wrong: </h2>
          <hr className="dividergeneral mb-5"></hr>
            <p className=" mb-2">
              In this paragraph will discuss the experiments that were attempted, but ultimately unsuccessful along 
              with the reasons for their failure.
            </p>         
            <div>{/*Surface expression */}
              <h3 className=" mb-5 mt-10" id="Surface_Expression_EC20_e">Surface expression of EC20: </h3>
              <div>{/*Proteinase K*/}
                <div>{/*Experiment 1*/}
                <h4 className="mb-3" id="PK_Experiment_EC20">Proteinase K assay: </h4>
                  <p className=" mb-2"onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                    To confirm the <span>surface display</span> of our proteins of interest, we conducted an experiment 
                    utilizing the enzyme proteinase K (PK). Proteinase K is able to degrade extracellular 
                    proteins but cannot penetrate bacterial cells. When a protein is present prior to PK 
                    treatment and absent afterward, it signifies susceptibility to proteinase K and, 
                    consequently, surface display.<br></br>
                  </p>

                  <p className=" mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    Considering the outcomes of the SpaC assay, we opted to validate the activity of 
                    Proteinase K.                
                  </p>
                  </div>
                <div>{/*Enzymatic Assay*/}
                <h4 className="mb-3" id="Enzymatic_Assay_PK_EC20_e">Proteinase K - enzymatic activity assay: </h4>
                  <p className=" mb-2">
                  The evaluation of PK activity involves dissolving GFP in water containing PK and measuring 
                  fluorescence. Over time, PK should degrade all GFP, leading to the complete absence of 
                  detectable fluorescence.<br></br>
                  <a href="#Table1_EC20">Table 1</a> displays fluorescence measurements before and after 
                  incubation with PK under various conditions. Please note that the machine did not provide a 
                  specific unit for these values.<br></br>
                  To normalize the measured change, the percentage change from the initial signal to the final 
                  signal is provided in <a href="#Table2_EC20">Table 2</a>.
                  We did not observe degradation exceeding 30% in any of the tested conditions. In a single 
                  condition, a signal increase was detected, which we attribute to potential random variation. 
                  Nevertheless, we interpreted this as minimal to no sample degradation.
                  </p>

                  <div class="result-centered">
                    <figure>
                      <div id="Table1_EC20"></div>
                      <Figure10/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 1:</u>{" "}
                        </b>
                        Different concentrations of GFP were incubated with PK at various temperatures. The first 
                        value represents the initial signal, while the value following the arrow represents the 
                        signal after incubation. 
                      </figcaption>
                      <br></br>
                      <div id="Table2_EC20"></div>
                      <Figure11/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 2:</u>{" "}
                        </b>
                        Percentage change in fluorescence (excitation: 488 nm, emission: 509 nm) pre- and 
                        post-incubation with PK across diverse GFP concentrations and temperatures. Blue denotes 
                        signal reduction, while orange signifies enhancement.
                      </figcaption>
                    </figure>
                  </div>

                  <p className=" mb-2" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    For our experiments, complete protein degradation is necessary. However, due to the 
                    insufficient <span>enzymatic activity</span> of our PK, we decided to discontinue the <span>proteolytic assay</span>. 
                    To confirm the presence of the protein on the surface, we adopted an <span>immunofluorescence</span> (IF) 
                    approach.                  
                  </p>
                </div>
              </div>
            </div>
            <div>{/*Sonication*/}
              <h3 className=" mb-5 mt-10" id="Sonication_EC20_e">Sonication: </h3>
                  <p className=" mb-2" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                  To improve resolution and eliminate unwanted non-protein debris, we utilized <span>sonication</span> to 
                  disrupt the bacteria, and then performed centrifugation to remove undesirable material. The 
                  resulting supernatant containing proteins was collected for use in subsequent experiments.<br></br>
                  To quantify the protein, we conducted a BCA assay. We prepared a dilution series of the BCA 
                  standard and generated a standard curve using the signal values obtained (as shown in 
                  <a href="#Table3_EC20">Table 3</a> and <a href="#Figure7_SpaC">Figure 1</a>). <br></br>

                  A linear regression analysis was conducted to estimate the concentration based on the signal, 
                  resulting in the following relationship: <br></br><br></br>
                  <center>C(S)=1.869*S+0.213<br></br><br></br></center>
                  Where C is the concentration to be calculated, and S is the signal measured.<br></br>
                  The R-squared value quantifies the degree to which the observed data points align with the 
                  linear regression obtained. A perfect match is represented by a value of 1. We obtained an 
                  R-squared value of 0.997, indicating that the model accurately represents the concentrations 
                  derived from the signals.<br></br>
                  <a href="#Table4_EC20">Table 4</a> displays the recorded signals along with the corresponding 
                  computed concentrations. <br></br>

                  Before preparing the Western blot, we boiled the proteins. Our addition of 2X SDS loading dye 
                  further diluted the samples by a factor of 1:2.<br></br>
                  The target protein load was established at 40 µg. Nevertheless, because of the volume 
                  limitations of a single gel well (40 µL), there was a restriction on the maximum quantity of 
                  protein that could be loaded. Table 4 demonstrates the highest permissible protein load for 
                  each condition. The data shows that none of the samples had a concentration adequate to the 
                  required amount of protein.


                  </p>

                  <div class="result-centered">
                    <figure>
                      <div id="Table3_EC20"></div>
                      <Figure30/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 3:</u>{" "}
                        </b>
                        BCA assay results for the dilution series. 
                      </figcaption>
                      <br></br>
                      <div id="Figure7_SpaC"></div>
                      <Figure31/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Figure 1:</u>{" "}
                        </b>
                        Standard curve for OD 562 based on experimental data.
                      </figcaption>
                      <div id="Table4_EC20"></div>
                      <Figure3/>
                      <br></br>
                      <figcaption className="mt-2 mb-10">
                        <b>
                          <u>Table 4:</u>{" "}
                        </b>
                        Measured signals, corresponding concentrations, and protein mass in 40 µL for three samples. 
                      </figcaption>
                    </figure>
                  </div>

                  <p className=" mb-2">{/*Outlook */}
                    <u><b>Conclusions:</b></u><br></br>
                    Sonication proved ineffective in yielding sufficient protein for our experiments. Given the 
                    challenges associated with the 50 mL volume, including space limitations in the incubator 
                    and high LB medium consumption, we chose not to repeat the experiment with larger volumes. 
                    In subsequent experiments, we no longer employed sonication.               
                  </p>
                </div>



        <br></br><br></br>
        
 {/** 
        <h2 className="mt-20" id="References"> References </h2>
         <hr className="dividergeneral mb-5"></hr>
        <ul>
          <ol type="1">
            <li id="reference1">
              {" "}
              This is a reference{" "}
              <a href="https://r.mtdv.me/important-reference">
                <i>
                  <strong>The reference</strong>
                </i>
              </a>
            </li>
            <li id="reference2">
              {" "}
              This is{" "}
              <i>
                <strong>another</strong>
              </i>{" "}
              reference{" "}
            </li>
          </ol>
        </ul>*/}
      </div>
    </div>
  );
};

export default Article;
